import { tv } from 'tailwind-variants';

type FileType = 'pdf' | 'word' | 'excel' | 'ppt';

// Resolve file type from a filename extension; null when extension is unknown
export function getFileType(filename: string | undefined): FileType | null {
  const ext = filename?.split('.').pop()?.toLowerCase();
  if (ext === 'pdf') return 'pdf';
  if (ext === 'doc' || ext === 'docx') return 'word';
  if (ext === 'xls' || ext === 'xlsx' || ext === 'xlsm') return 'excel';
  if (ext === 'ppt' || ext === 'pptx') return 'ppt';
  return null;
}

export const iconVariants = tv({
  variants: {
    fileType: {
      word: 'fa-light fa-file-word text-blue-500',
      excel: 'fa-light fa-file-excel text-green-500',
      pdf: 'fa-kit fa-file-earmark-pdf text-red-500',
      ppt: 'fa-light fa-file-powerpoint text-orange-500',
    },
  },
});

interface FileIconProps {
  filename?: string;
  className?: string;
}

// File-type icon resolved from the filename extension; renders nothing for unknown types
export const FileIcon = ({ filename, className }: FileIconProps) => {
  const fileType = getFileType(filename);
  if (!fileType) return null;
  return <i className={iconVariants({ fileType, class: className })} aria-hidden="true" />;
};
